import LoginAlertModal from 'components/login/LoginAlertModal'
import React, { useEffect, useMemo, useState } from 'react'
import RequestQuestionnaireDrawer from './drawer'

export default function RequestQuestionnaireDrawerTrigger(props) {
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    setOpen(urlParams.get('focus_questionnaire_request'))
  }, [])

  const redirectUrl = useMemo(
    () =>
      props?.initialBuilding?.id
        ? `/users/login/?redirect_to=/buildings/${props?.initialBuilding?.id}?focus_questionnaire_request=true`
        : '/users/login/?redirect_to=/buildings',
    [props?.initialBuilding?.id]
  )

  return (
    <>
      <button onClick={handleOpen} type="button" className="btn-base btn-dark-green" style={{ marginTop: '12px' }}>
        request questionnaire
      </button>
      {props.userSignedIn ? (
        <RequestQuestionnaireDrawer show={open} onClose={handleClose} {...props} />
      ) : (
        <LoginAlertModal open={open} onClose={handleClose} redirectUrl={redirectUrl} />
      )}
    </>
  )
}
